import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ForgetPasswordModel } from "../../../common/utils";

const initialState: ForgetPasswordModel = {
  email: "",
  forgetPasswordmessage: "",
};

const forgetPasswordSlice = createSlice({
  name: "forgetPassword",
  initialState,
  reducers: {
    setEmail: (
      state: ForgetPasswordModel,
      action: PayloadAction<ForgetPasswordModel>,
    ) => {
      state.email = action.payload.email;
      state.forgetPasswordmessage = action.payload.forgetPasswordmessage;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setEmail } = forgetPasswordSlice.actions;

export default forgetPasswordSlice.reducer;
